var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getLoadingStatus)?_c('v-progress-circular',{staticClass:"progress-bar",attrs:{"value":_vm.getProgressPercent,"indeterminate":"","rotate":-90,"size":"80","width":"8","color":"teal"}},[_vm._v(_vm._s(_vm.getProgressPercent)+" %")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }